<template>
  <v-app>
    <div class="ranking-background">
      <v-main class="ranking-main">
        <v-container fluid>
          <!-- TÍTULO Y FILTROS -->
          <v-row class="mb-4">
            <v-col cols="12">
              <v-card class="glass-card" elevation="16">
                <v-card-title class="headline white--text primary">
                  <v-icon left large color="white">mdi-podium-gold</v-icon>
                  Ranking Anual
                  <v-spacer></v-spacer>
                  <v-btn dark color="#24232d" class="mt-8 mb-4" @click="volver">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Volver
                  </v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                  <v-row>
                    <v-col cols="12" md="3" class="mt-4">
                      <v-select
                        v-model="añoSeleccionado"
                        :items="añosDisponibles"
                        label="Año"
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="3" class="mt-4">
                      <v-select
                        v-model="deporteSeleccionado"
                        :items="deportes"
                        label="Deporte"
                        outlined
                        dense
                        prepend-inner-icon="mdi-tennis-ball"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="3" class="mt-4">
                      <v-select
                        v-model="categoriaSeleccionada"
                        :items="categorias"
                        label="Categoría"
                        outlined
                        dense
                        prepend-inner-icon="mdi-account-group"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="3" class="mt-4">
                      <v-select
                        v-model="generoSeleccionado"
                        :items="generos"
                        label="Género"
                        outlined
                        dense
                        prepend-inner-icon="mdi-gender-male-female"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="3" class="buscar-section">
                      <v-btn
                        color="primary"
                        large
                        block
                        @click="cargarRanking"
                        :loading="cargando"
                      >
                        <v-icon left>mdi-magnify</v-icon>
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- TABLA DE RANKING -->
          <v-row v-if="ranking">
            <v-col cols="12">
              <v-card class="glass-card" elevation="16">
                <v-card-title class="d-flex justify-space-between align-center">
                  <span>
                    Ranking {{ añoSeleccionado }} -
                    {{ categoriaSeleccionada }} - {{ generoSeleccionado }}
                  </span>

                  <v-chip color="primary" dark large>
                    {{ ranking.jugadores.length }} Jugadores
                  </v-chip>
                </v-card-title>

                <v-card-text>
                  <!-- PODIO (Top 3) -->
                  <v-row v-if="ranking.jugadores.length >= 3" class="mb-6">
                    <!-- 2º LUGAR -->
                    <v-col
                      cols="12"
                      md="4"
                      class="d-flex align-center justify-center"
                    >
                      <v-card
                        class="podio-card segundo-lugar"
                        elevation="8"
                        width="100%"
                      >
                        <v-card-text class="text-center pa-6">
                          <div class="podio-numero">2</div>
                          <v-icon size="60" color="silver">mdi-medal</v-icon>
                          <div class="podio-nombre mt-2">
                            {{ ranking.jugadores[1].nombreJugador }}
                          </div>
                          <v-chip color="silver" dark large class="mt-2">
                            {{ ranking.jugadores[1].puntosTotal }} pts
                          </v-chip>
                          <div class="text-caption mt-2">
                            {{ ranking.jugadores[1].competencias.length }}
                            competencia(s)
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- 1º LUGAR -->
                    <v-col
                      cols="12"
                      md="4"
                      class="d-flex align-center justify-center"
                    >
                      <v-card
                        class="podio-card primer-lugar"
                        elevation="12"
                        width="100%"
                      >
                        <v-card-text class="text-center pa-6">
                          <div class="podio-numero">1</div>
                          <v-icon size="80" color="amber darken-2"
                            >mdi-trophy</v-icon
                          >
                          <div class="podio-nombre mt-2">
                            {{ ranking.jugadores[0].nombreJugador }}
                          </div>
                          <v-chip
                            color="amber darken-2"
                            dark
                            x-large
                            class="mt-2"
                          >
                            {{ ranking.jugadores[0].puntosTotal }} pts
                          </v-chip>
                          <div class="text-caption mt-2">
                            {{ ranking.jugadores[0].competencias.length }}
                            competencia(s)
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- 3º LUGAR -->
                    <v-col
                      cols="12"
                      md="4"
                      class="d-flex align-center justify-center"
                    >
                      <v-card
                        class="podio-card tercer-lugar"
                        elevation="8"
                        width="100%"
                      >
                        <v-card-text class="text-center pa-6">
                          <div class="podio-numero">3</div>
                          <v-icon size="60" color="orange darken-3"
                            >mdi-medal</v-icon
                          >
                          <div class="podio-nombre mt-2">
                            {{ ranking.jugadores[2].nombreJugador }}
                          </div>
                          <v-chip
                            color="orange darken-3"
                            dark
                            large
                            class="mt-2"
                          >
                            {{ ranking.jugadores[2].puntosTotal }} pts
                          </v-chip>
                          <div class="text-caption mt-2">
                            {{ ranking.jugadores[2].competencias.length }}
                            competencia(s)
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>

                  <!-- TABLA COMPLETA -->
                  <v-data-table
                    :headers="headers"
                    :items="ranking.jugadores"
                    :items-per-page="20"
                    class="elevation-2 ranking-table"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 50, -1],
                      itemsPerPageText: 'Filas por página',
                    }"
                  >
                    <template v-slot:item.posicion="{ item, index }">
                      <v-chip
                        small
                        :color="getColorPosicion(index + 1)"
                        :dark="index < 3"
                      >
                        <v-icon v-if="index === 0" small left>mdi-crown</v-icon>
                        {{ index + 1 }}
                      </v-chip>
                    </template>

                    <template v-slot:item.nombreJugador="{ item }">
                      <div class="font-weight-medium">
                        {{ item.nombreJugador }}
                      </div>
                      <div class="text-caption grey--text">
                        ID: {{ item.idJugador }}
                      </div>
                    </template>

                    <template v-slot:item.puntosTotal="{ item }">
                      <v-chip color="amber darken-2" dark>
                        <v-icon small left>mdi-star</v-icon>
                        {{ item.puntosTotal }}
                      </v-chip>
                    </template>

                    <template v-slot:item.competencias="{ item }">
                      <v-chip small>
                        {{ item.competencias.length }} competencia(s)
                      </v-chip>
                    </template>

                    <template v-slot:item.acciones="{ item }">
                      <v-btn
                        small
                        color="primary"
                        @click="verDetalleJugador(item)"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Ver Detalle
                      </v-btn>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <v-card outlined>
                          <v-card-title class="subtitle-2">
                            Detalle de Competencias
                          </v-card-title>
                          <v-card-text>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th>Fecha</th>
                                    <th>Competencia</th>
                                    <th>Tipo</th>
                                    <th>Posición</th>
                                    <th>Puntos</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="comp in item.competencias"
                                    :key="comp.idCompetencia"
                                  >
                                    <td>
                                      {{
                                        new Date(
                                          comp.fecha,
                                        ).toLocaleDateString()
                                      }}
                                    </td>
                                    <td>{{ comp.nombreCompetencia }}</td>
                                    <td>
                                      <v-chip
                                        x-small
                                        :color="
                                          comp.tipoCompetencia === 'Torneo'
                                            ? 'blue'
                                            : 'green'
                                        "
                                        dark
                                      >
                                        {{ comp.tipoCompetencia }}
                                      </v-chip>
                                    </td>
                                    <td>{{ comp.posicion }}º</td>
                                    <td>
                                      <strong>{{ comp.puntos }}</strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card-text>
                        </v-card>
                      </td>
                    </template>
                    <!-- SIN DATOS -->
                    <template v-slot:no-data>
                      <div class="text-center py-4">
                        <v-icon size="64" color="grey lighten-2"
                          >mdi-trophy-outline</v-icon
                        >
                        <p class="subtitle-1 grey--text mt-2">
                          No hay jugadores que coincidan con los filtros
                          ingresados
                        </p>
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- MENSAJE CUANDO NO HAY DATOS -->
          <v-row v-else-if="!cargando">
            <v-col cols="12">
              <v-alert type="info" prominent border="left">
                <v-row align="center">
                  <v-col class="grow">
                    <div class="text-h6">
                      No hay datos de ranking disponibles
                    </div>
                    <div>
                      Seleccione un año, categoría y género para ver el ranking.
                    </div>
                    <div>
                      Sólo contabilizan las competencias en estado finalizado.
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-icon size="64">mdi-trophy-outline</v-icon>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>

    <!-- MODAL DE DETALLE DE JUGADOR -->
    <v-dialog v-model="modalDetalleVisible" max-width="700px" scrollable>
      <v-card v-if="jugadorDetalle" class="mb-0">
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-account</v-icon>
          {{ jugadorDetalle.nombreJugador }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalDetalleVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- RESUMEN -->
          <v-row>
            <v-col cols="12" sm="4">
              <v-card color="primary" dark>
                <v-card-text class="text-center">
                  <div class="text-h4">{{ jugadorDetalle.puntosTotal }}</div>
                  <div>Puntos Totales</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card color="success" dark>
                <v-card-text class="text-center">
                  <div class="text-h4">
                    {{ jugadorDetalle.competencias.length }}
                  </div>
                  <div>Competencias</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card color="amber darken-2" dark>
                <v-card-text class="text-center">
                  <div class="text-h4">
                    {{ calcularPromedioPuntos(jugadorDetalle) }}
                  </div>
                  <div>Promedio</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- LISTA DE COMPETENCIAS -->
          <v-list two-line class="mt-4">
            <v-subheader>Historial de Competencias</v-subheader>
            <v-list-item
              v-for="comp in jugadorDetalle.competencias"
              :key="comp.idCompetencia"
            >
              <v-list-item-avatar>
                <v-icon
                  :color="comp.tipoCompetencia === 'Torneo' ? 'blue' : 'green'"
                >
                  {{
                    comp.tipoCompetencia === "Torneo"
                      ? "mdi-tournament"
                      : "mdi-table"
                  }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{
                  comp.nombreCompetencia
                }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ new Date(comp.fecha).toLocaleDateString() }} | Posición:
                  {{ comp.posicion }}º
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-chip color="amber darken-2" dark>
                  {{ comp.puntos }} pts
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script lang="ts" setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { calcularRankingAnual, type RankingAnual } from "@/utils/rankings";
import axios from "@/axios-auth";
import { getCategoriasConfig, getDeportesConfig } from "@/utils/models";

const { proxy } = getCurrentInstance();

const añoSeleccionado = ref(new Date().getFullYear());
const categoriaSeleccionada = ref("");
const deporteSeleccionado = ref("");
const generoSeleccionado = ref("");
const cargando = ref(false);
const ranking = ref<RankingAnual | null>(null);

const modalDetalleVisible = ref(false);
const jugadorDetalle = ref<any>(null);

const añosDisponibles = ref<number[]>([]);

const headers = [
  { text: "Pos.", value: "posicion", sortable: false, width: "100" },
  { text: "Jugador", value: "nombreJugador", sortable: false },
  { text: "Puntos", value: "puntosTotal", sortable: true },
  { text: "Competencias", value: "competencias", sortable: false },
  { text: "Acciones", value: "acciones", sortable: false, align: "center" },
];

const tiposCompetencia = [
  { text: "Dobles", value: "Dobles" },
  { text: "Single", value: "Single" },
];

const generos = [
  { text: "Masculino", value: "Masculino" },
  { text: "Femenino", value: "Femenino" },
  { text: "Mixto", value: "Mixto" },
];

function getColorPosicion(posicion: number): string {
  if (posicion === 1) return "amber darken-1";
  if (posicion === 2) return "grey lighten-1";
  if (posicion === 3) return "orange darken-3";
  return "grey";
}

const deportes = ref([]);
const categorias = ref([]);

function calcularPromedioPuntos(jugador: any): number {
  if (!jugador.competencias.length) return 0;
  return Math.round(jugador.puntosTotal / jugador.competencias.length);
}

function verDetalleJugador(jugador: any) {
  jugadorDetalle.value = jugador;
  modalDetalleVisible.value = true;
}

async function cargarRanking() {
  if (!categoriaSeleccionada.value || !generoSeleccionado.value) {
    proxy.$swal({
      icon: "warning",
      title: "Faltan filtros",
      text: "Debe seleccionar categoría y género",
      timer: 3000,
    });
    return;
  }

  cargando.value = true;

  try {
    // Llamar al endpoint para obtener los rankings (ya filtrados en backend)
    const { data } = await axios.get("/Ranking/GetRankings", {
      params: {
        year: añoSeleccionado.value,
        deporte: deporteSeleccionado.value,
        categoria: categoriaSeleccionada.value,
        genero: generoSeleccionado.value,
        idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
      },
    });

    const rankings = data
      ? data.map((item: any) => {
          return {
            ...item,
            jugadores: JSON.parse(item.jugadores),
          };
        })
      : [];

    const jugadoresAplanados: any[] = [];

    rankings.forEach((competencia: any) => {
      competencia.jugadores.forEach((jugador: any) => {
        jugadoresAplanados.push({
          idJugador: jugador.idJugador,
          nombreJugador: jugador.nombreJugador,
          posicion: jugador.posicion,
          puntosAsignados: jugador.puntosAsignados,
          idCompetencia: competencia.idTorneo,
          tipoCompetencia: competencia.tipoCompetencia || "Torneo",
          nombreCompetencia:
            competencia.nombreCompetencia ||
            `Competencia ${competencia.idTorneo}`,
          categoria: competencia.categoria,
          genero: competencia.genero,
          fecha: competencia.fecha || new Date().toISOString(),
        });
      });
    });

    // Calcular el ranking con los datos pre-filtrados
    ranking.value = calcularRankingAnual(jugadoresAplanados);

    if (ranking.value.jugadores.length === 0) {
      proxy.$swal({
        icon: "info",
        title: "Sin resultados",
        text: "No hay datos de ranking para los filtros seleccionados",
        timer: 3000,
      });
    }
  } catch (error) {
    console.error("Error cargando ranking:", error);
    proxy.$swal({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar el ranking",
      timer: 3000,
    });
  } finally {
    cargando.value = false;
  }
}

function volver() {
  proxy.$router.push("/Home");
}

function cargarFiltrosDisponibles() {
  // Cargar años disponibles (últimos 5 años)
  const añoActual = new Date().getFullYear();
  añosDisponibles.value = Array.from({ length: 5 }, (_, i) => añoActual - i);
  categorias.value = getCategoriasConfig(
    proxy.$store.state.usuario.institucion.idInstitucion,
  ).categorias;
  deportes.value = getDeportesConfig(
    proxy.$store.state.usuario.institucion.idInstitucion,
  ).deportes.filter((deporte) => deporte.value !== "Futbol");
}

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  cargarFiltrosDisponibles();
});
</script>

<style scoped lang="scss">
.ranking-background {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.ranking-main {
  padding: 20px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 16px !important;
}

// Podio
.podio-card {
  transition: all 0.3s;
  border-radius: 16px !important;

  &:hover {
    transform: translateY(-8px);
  }

  &.primer-lugar {
    background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%) !important;
    transform: scale(1.05);
  }

  &.segundo-lugar {
    background: linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%) !important;
  }

  &.tercer-lugar {
    background: linear-gradient(135deg, #cd7f32 0%, #e9a762 100%) !important;
  }
}

.podio-numero {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 2rem;
  font-weight: 900;
  opacity: 0.3;
}

.podio-nombre {
  font-size: 1.1rem;
  font-weight: 700;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

// Tabla
.ranking-table {
  :deep(thead) {
    background-color: #f5f5f5;

    th {
      font-weight: 700 !important;
    }
  }

  :deep(tbody tr:hover) {
    background-color: #f9f9f9 !important;
  }
}

.buscar-section {
  margin-top: 26px;
  padding-top: 0px;
}

// Responsive
@media (max-width: 960px) {
  .podio-card {
    margin-bottom: 16px;

    &.primer-lugar {
      transform: scale(1);
      order: -1;
    }
  }
}
</style>
